function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect, useContext } from 'react';
import { connect, useSelector } from 'react-redux';
import { modalActions } from '../../../reducers/modal.reducer';
import { cmsActions } from '../../../reducers/cms.reducer';
import { posActions } from '../../../reducers/pos.reducer';
import useEnvArr from '../../../helpers/hooks/useEnvArr';
import PageData from './Page.context';
import Table from '../../common/table/Table.react';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
import Button from '../../common/Button.react';
import AddArticleToPage from './AddArticleToPage.modal';
import ArticlesAdd from '../../articles/add/ArticlesAdd.modal';
import PageArticlesSlot from './PageArticlesSlot.modal';

// TODO :: Stop if app / type is not in constants
var PageArticles = function PageArticles(_ref) {
  var pageID = _ref.pageID,
    articlesAction = _ref.articlesAction,
    addModalAction = _ref.addModalAction,
    pagesAction = _ref.pagesAction;
  var navigate = useNavigate();
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    tableData = _useState2[0],
    setTableData = _useState2[1];
  var cmsArticles = useSelector(function (s) {
    return s.cms.articles;
  });
  var cmsEnvironments = useSelector(function (s) {
    return s.settings.constants.environments;
  });
  var envArr = useEnvArr();
  var _useContext = useContext(PageData),
    _useContext2 = _slicedToArray(_useContext, 1),
    state = _useContext2[0];
  var app = state.app,
    type = state.type,
    articleType = state.articleType,
    archived = state.archived;
  var articles = state.articles;
  useEffect(function () {
    articlesAction({
      pageID: pageID
    });
  }, [pageID]);
  var getTitle = function getTitle(id) {
    if (id in cmsArticles) return cmsArticles[id]['title'];
    return '';
  };
  var getPublished = function getPublished(id, environment) {
    var tmp = articles.find(function (x) {
      return x.articleID._id === id;
    });
    if (tmp !== null && tmp !== void 0 && tmp.published.find(function (x) {
      return x.clientEnv === environment;
    })) return true;
    return false;
  };
  useEffect(function () {
    var columns = {
      id: {
        title: '_id',
        visible: false
      },
      pageID: {
        title: 'pageID',
        visible: false
      },
      title: {
        title: 'Title',
        onClick: function onClick(_ref2) {
          var row = _ref2.row;
          return navigate("/article/".concat(row._id));
        }
      },
      slot: {
        title: 'Slot',
        size: 'contain',
        onClick: function onClick(_ref3) {
          var row = _ref3.row;
          addModalAction({
            component: /*#__PURE__*/React.createElement(PageArticlesSlot, {
              articleID: row._id,
              pageID: row.pageID
            })
          });
        }
      }
    };
    cmsEnvironments.forEach(function (x) {
      if (x.clientApp === app && envArr.includes(x.value)) {
        columns[x.value] = {
          title: x.name,
          size: 'contain',
          onClick: function onClick(_ref4) {
            var row = _ref4.row,
              key = _ref4.key;
            pagesAction({
              formData: {
                pageID: pageID,
                articleID: row._id,
                env: key,
                isPublished: row[key] ? false : '1970-01-01'
              },
              method: 'put',
              route: 'article-publish'
            });
          }
        };
      }
    });
    setTableData({
      columns: columns,
      data: Object.values(articles).filter(function (x) {
        return !x.archived;
      }).map(function (x) {
        var tmpObj = {
          _id: x.articleID._id,
          title: getTitle(x.articleID._id),
          pageID: pageID,
          slot: x.slot
        };
        cmsEnvironments.forEach(function (y) {
          if (envArr.includes(y.value)) tmpObj[y.value] = getPublished(x.articleID._id, y.value);
        });
        return tmpObj;
      }),
      sort: {
        by: 'slot'
      }
    });
  }, [articles, cmsArticles, cmsEnvironments]);
  if (type !== 'article-page') return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Articles"
  }), !archived && /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      addModalAction({
        component: /*#__PURE__*/React.createElement(AddArticleToPage, {
          pageID: pageID,
          app: app
        })
      });
    },
    type: "cancel",
    label: "Link Article",
    permission: "edit-pos-sections"
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      addModalAction({
        component: /*#__PURE__*/React.createElement(ArticlesAdd, {
          pageID: pageID,
          app: app,
          articleType: articleType
        })
      });
    },
    label: "New Article",
    permission: "edit-pos-sections"
  }))), /*#__PURE__*/React.createElement(Table, tableData)));
};
var mdtp = {
  articlesAction: cmsActions.articles,
  pagesAction: posActions.pages,
  addModalAction: modalActions.add
};
export default connect(null, mdtp)(PageArticles);